module.exports = __webpack_public_path__ + "media/images/cart-f1535641d9050b89bc7b7115f4209134.png";